<template>
  <div class="header">
    <div class="contanier">
      <div>
        <div class="logo">
          <img src="@/assets/home/headerlogo.png" />
        </div>
        <div class="right">
          <ul class="menu">
            <li
              v-for="(item, index) of headerList"
              :key="index"
              @mousemove="() => (item.showChild = true)"
              @mouseleave="() => (item.showChild = false)"
            >
              <div
                :class="selectUrl === item.url.split('?')[0] ? 'active' : ''"
                @click="goUrl(item.url)"
              >
                {{ item.name }}
              </div>
              <div
                class="childMenu"
                v-if="item.showChild && item.child && item.child.length > 0"
              >
                <span
                  v-for="(ele, index2) of item.child"
                  :key="index2"
                  @click="goUrl(ele.url)"
                  >{{ ele.name }}</span
                >
              </div>
            </li>
          </ul>
        </div>
        <!-- <div class="language">En</div> -->
      </div>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      headerList: [
        {
          name: "首页",
          url: "/index",
          showChild: false,
        },
        {
          name: "集团概况",
          url: "/groupOverview?chooseKey=1",
          showChild: false,
          child: [
            {
              name: "集团简介",
              url: "/groupOverview?chooseKey=1",
            },
            {
              name: "领导班子",
              url: "/groupOverview?chooseKey=2",
            },
            {
              name: "组织架构",
              url: "/groupOverview?chooseKey=3",
            },
            {
              name: "集团荣誉",
              url: "/groupOverview?chooseKey=4",
            },
          ],
        },
        {
          name: "新闻中心",
          url: "/newsCenter?id=4",
          showChild: false,
          child: [
            {
              name: "领导关怀",
              url: "/newsCenter?id=4",
            },
            {
              name: "集团要闻",
              url: "/newsCenter?id=1",
            },
            {
              name: "成员动态",
              url: "/newsCenter?id=2",
            },
          ],
        },
        {
          name: "板块业务",
          url: "/blockBusiness?id=126",
          showChild: false,
          child: [
            {
              name: "新能源板块",
              url: "/blockBusiness?id=126",
            },
            {
              name: "航空航天复材制造板块",
              url: "/blockBusiness?id=129",
            },
            {
              name: "海洋船舶及相关制造",
              url: "/blockBusiness?id=159",
            },
            {
              name: "其他装备制造板块",
              url: "/blockBusiness?id=169",
            },
            {
              name: "工美文化",
              url: "/blockBusiness?id=164",
            },
            {
              name: "军工板块",
              url: "/blockBusiness?id=135",
            },
            {
              name: "民爆板块",
              url: "/blockBusiness?id=132",
            },
            {
              name: "产业服务板块",
              url: "/blockBusiness?id=174",
            },
          ],
        },
        {
          name: "信息公开",
          url: "/informationOpen?id=1",
          showChild: false,
          child: [
            {
              name: "人才招聘",
              url: "/informationOpen?id=1",
            },
            {
              name: "公示公告",
              url: "/informationOpen?id=2",
            },
            {
              name: "联系我们",
              url: "/informationOpen?id=4",
            },
          ],
        },
      ],
      selectUrl: "",
    };
  },
  methods: {
    goUrl(url) {
      console.log(url, "url--------");
      if (url) {
        this.$router.push(url);
      }
    },
  },
  mounted() {},
  watch: {
    $route: {
      handler(newval, oldval) {
        this.selectUrl = newval.path;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style scoped lang="less">
.header {
  width: 100%;
  height: 116px;
  box-sizing: border-box;
  background: #fff;
  z-index: 9999;
}
.contanier {
  width: 100%;
  height: 116px;
  // background: rgba(0,106,177,0.9);
  // box-shadow: 0px 3px 18px 0.8px rgba(70, 140, 152, 0.5);
  position: relative;
}
.language {
  position: absolute;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
  width: 21px;
  height: 21px;
  border-radius: 4px;
  border: 2px solid #333333;
  color: #333333;
  text-align: center;
  line-height: 19px;
  cursor: pointer;
}
.contanier > div {
  width: 100%;
  height: 116px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.right {
  height: 100%;
  flex: 1;
  box-sizing: border-box;
  padding-left: 170px;
}
.logo {
  width: 260px;
  height: 100%;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 200px;
    height: 68px;
  }
}
.menu {
  height: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  margin-right: 140px;
  li {
    height: 100%;
    line-height: 115px;
    position: relative;
  }
}
.menu li div:nth-child(1) {
  cursor: pointer;
  font-size: 20px;
  color: #333333;
  position: relative;
}
.menu li .active {
  color: #333333;
  font-weight: 600;
}
.active::after {
  content: "";
  width: 100%;
  height: 2px;
  background: #fff;
  transform: translateX(-50%);
  position: absolute;
  left: 50%;
  bottom: 35px;
}
.menu li .childMenu {
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: 116px;
  width: 220px;
  padding: 10px 0;
  span {
    color: #333;
    line-height: 40px;
    white-space: nowrap;
    cursor: pointer;
  }
  span:hover {
    color: rgba(0, 106, 177, 0.9);
  }
}
</style>
